import { render, staticRenderFns } from "./list-employee.vue?vue&type=template&id=50b1837b"
import script from "./list-employee.vue?vue&type=script&lang=js"
export * from "./list-employee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports